var _defs, _line, _path, _path2, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#424242;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-question") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 23.25,
    x2: 0.75,
    y2: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75,20.293l3.154-.97a9.61,9.61,0,0,1,7.864,1,9.615,9.615,0,0,0,7.679,1.056l2.987-.853a1.126,1.126,0,0,0,.816-1.082V3.637a1.126,1.126,0,0,0-1.434-1.082l-2.369.677a9.615,9.615,0,0,1-7.679-1.056,9.61,9.61,0,0,0-7.864-1L.75,2.145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.125,9.375A1.875,1.875,0,1,1,12,11.25v1.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 15.75,
    x2: 12,
    y2: 15.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,15.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,15.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagQuestion);
export default __webpack_public_path__ + "static/media/flag-question.7b1ebf589957527fc64c5d68b9df8a97.svg";
export { ForwardRef as ReactComponent };